<template>
	<v-container>
		<v-row class="contentRow">
			<v-col cols="auto" class="darkColor--text">
                <h1 class="text-left mb-0">Initiator View</h1>
				<h1 class="text-left mb-0">Auditor View</h1>
			</v-col>
			<v-col cols="auto">
				<v-btn
					class="mt-2"
					dark
					v-if="$accessToOperation('AR','C')"
					color="orangeButton"
					@click="checkPackageAndNavigate"
					>
					<v-icon left small>fas fa-plus</v-icon>
					Onsite Audit Request
					</v-btn>

			</v-col>
			<v-col cols="12" class="flex-grow-0 pt-20">
				<p>
                    This is the overview of onsite audits and templates you have sent. Completed onsite audits have been filled out by the auditor and are awaiting your assessment.
                    <br />Pending Template Requests 'Approval Pending...' are waiting for auditor approval, while 'Continue' allows sending onsite requests. Pending Onsite-Audit Requests 
					need to be completed by the auditor.
					This is the overview of audits you have sent. Completed audits have been filled out by the recipient and are awaiting your assessment.
					<br />Pending audits have not yet been completed by the submitter.
				</p>
			</v-col>
			<v-spacer />

			<v-col cols="12">
				<v-tabs background-color="transparent" light icons-and-text>
					<v-tab>
						Pending
						<v-icon>fas fa-hourglass-half</v-icon>
					</v-tab>	
					<v-tab>
						Completed
						<v-icon>fas fa-check</v-icon>
					</v-tab>

					<!-- Searching -->
					
					<v-tab-item>
						<v-row class="mt-3">
							<v-col cols="3" class="pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Template"
									v-model="pending_templateName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="3" class="pl-0 pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Onsite-Auditor"
									v-model="pending_auditor"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="3" class="pl-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Supplier"
									v-model="pending_recipientName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="auto">
								<v-btn class="mr-1" medium elevation="0" :disabled="!pending_recipientName && !pending_templateName && !pending_auditor" color="white" @click="clear('p')">Clear</v-btn>
								<v-btn class="ml-0" medium color="primary" @click="search('p')"><v-icon>fas fa-search</v-icon>Search</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card elevation="0" outlined>
									<v-tabs background-color="transparent" color="orangeButton" v-model="pending">
										<v-tab key="pendingtemplate">
											Pending Template Requests
										</v-tab>

										<v-tab key="pendngaudit">
											Pending Onsite-Audit Requests
										</v-tab>
										<v-tab-item key="pendingtemplate">
											<br />
											<v-data-table
												:loading="loading"
												theme--
												light
												:headers="headersTemplates"
												:items="pagedTemplateApprovals"
												:options.sync="pendingtemplates_options"
												:server-items-length="templateApprovals.length"
												:items-per-page="pendingtemplates_options.itemsPerPage"
												class="light table"
												:footer-props="{
								'items-per-page-options': [5, 10, 15]
							}"
											>
												<template v-slot:item.auditorName="{ item }">
													<span v-if="item.auditorName">
														<v-tooltip top>
															<template v-slot:activator="{ props, on }">
																<span
																	v-bind="props"
																	v-on="on"
																>
																	{{ item.auditorName }}
																</span>
															</template>
															<span v-if="item.auditorType === 1">Internal Onsite-Auditor</span>
															<span v-if="item.auditorType === 2">External Onsite-Auditor's company name</span>
														</v-tooltip>
													</span>
													<span v-else class="error--text font-italic">Auditor need to register</span>
												</template>
												<template v-slot:item.status="{ item }">
													<div v-if="item.templateApproval === 0">
														<span class="orange--text">
															Approval Pending...
														</span>
													</div>
													<v-btn
														v-else-if="item.templateApproval === 1"
														@click="continueRequest(item)"
														color="primary"
														label
														small
														elevation="2"
													>
														Continue<v-icon right>fas fa-arrow-right</v-icon>
													</v-btn>
												</template>
												<template v-slot:item.view="{ item }">
													<v-btn
														@click="showRequestDialog(item)"
														color="primary"
														label
														small
														elevation="2"
													>
														<v-icon left small>far fa-eye</v-icon>
														View
													</v-btn>
												</template>
												<template v-slot:item.remove="{ item }">
													<v-btn small color="#B4B4B4" v-on:click="showDeleteDialog(item)">
														<v-icon small color="white">fas fa-times</v-icon>
													</v-btn>
												</template>
											</v-data-table>
										</v-tab-item>
										<v-tab-item key="pendngaudit">
											<br />
											<v-data-table
												:loading="loading"
												theme--
												light
												:headers="headersPending"
												:items="pagedPendingAudits"
												:options.sync="pendingaudits_options"
												:server-items-length="pendingaudits.length"
												:items-per-page="pendingaudits_options.itemsPerPage"
												class="light table"
												:footer-props="{
								'items-per-page-options': [5, 10, 15]
							}"
											>
												<template v-slot:item.auditorName="{ item }">
													<span v-if="item.auditorName">
														<v-tooltip top>
															<template v-slot:activator="{ props, on }">
																<span
																	v-bind="props"
																	v-on="on"
																>
																	{{ item.auditorName }}
																</span>
															</template>
															<span v-if="item.auditorType === 1">Internal Onsite-Auditor</span>
															<span v-if="item.auditorType === 2">External Onsite-Auditor's company name</span>
														</v-tooltip>
													</span>
													<span v-else class="error--text font-italic">Auditor need to register</span>
												</template>
												<template v-slot:item.onsiteDate="{ item }">
													<span v-if="item.visitDays && item.onsiteDate">
														{{ item.onsiteDate }}
														<v-tooltip top>
															<template v-slot:activator="{ on, attrs }">
																<span v-bind="attrs" v-on="on" class="grey--text text--darken-1">
																	({{ item.visitDays }} days)
																</span>
															</template>
															<span>Number of visit days</span>
														</v-tooltip>
													</span>
													<span v-else>
														{{ item.onsiteDate }}
													</span>
												</template>
												<template v-slot:item.view="{ item }">
													<v-btn
														@click="showRequestDialog(item)"
														color="primary"
														label
														small
														elevation="2"
													>
														<v-icon left small>far fa-eye</v-icon>
														View
													</v-btn>
												</template>
												<template v-slot:item.remove="{ item }">
													<v-btn small color="#B4B4B4" v-on:click="showDeleteDialog(item)">
														<v-icon small color="white">fas fa-times</v-icon>
													</v-btn>
												</template>
											</v-data-table>
										</v-tab-item>
									</v-tabs>
									<!-- <v-data-table
										:loading="loading"
										theme--
										light
										:headers="headersPending"
										:items="pagedPendingAudits"
										:options.sync="pendingaudits_options"
										:server-items-length="pendingaudits.length"
										:items-per-page="pendingaudits_options.itemsPerPage"
										class="light table"
										:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
									>
										<template v-slot:item.view="{ item }">
											<v-btn
												@click="showRequestDialog(item)"
												color="primary"
												label
												small
												elevation="2"
											>
												<v-icon left small>far fa-eye</v-icon>
												View
											</v-btn>
										</template>
										<template v-slot:item.remove="{ item }">
											<v-btn small color="#B4B4B4" v-on:click="showDeleteDialog(item)">
												<v-icon small color="white">fas fa-times</v-icon>
											</v-btn>
										</template>
									</v-data-table> -->
								</v-card>
							</v-col>
						</v-row>
					</v-tab-item>
					<v-tab-item>
						<v-row class="mt-3">
							<v-col cols="3" class="pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Template name"
									v-model="templateName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="3" class="pl-0 pr-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Onsite-Auditor"
									v-model="senderName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="3" class="pl-0">
								<v-text-field
									class="ml-0"
									dense
									background-color="#FAFAFA"
									prepend-inner-icon="fas fa-search"
									label="Supplier"
									v-model="supplierName"
									outlined
								>
								</v-text-field>
							</v-col>
							<v-col cols="auto">
								<v-btn v-if="assessment==1" :disabled = "!templateName && !senderName && !supplierName" class="mr-0" elevation="0" medium color="white" @click="clear('a')">Clear</v-btn>
								<v-btn v-else :disabled = "!templateName && !senderName && !supplierName" class="mr-1" medium color="white" elevation="0" @click="clear('c')">Clear</v-btn>
								<v-btn v-if="assessment==1" class="ml-0" medium color="primary" @click="search('a')"><v-icon>fas fa-search</v-icon>Search</v-btn>
								<v-btn v-else class="ml-0" medium color="primary" @click="search('c')"><v-icon>fas fa-search</v-icon>Search</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-card background-color="transparent" elevation="0" outlined>
										<v-tabs background-color="transparent" color="orangeButton" v-model="assessment">
											<v-tab key="notAssessed">
												Not assessed
											</v-tab>

											<v-tab key="assessed">
												assessed
											</v-tab>
											<v-tab-item key="notAssessed">
												<br />
												<v-data-table
													:loading="loading"
													theme--
													light
													:headers="headersCompleted"
													:items="pagedCompletedAudits"
													:options.sync="completedaudits_options"
													:server-items-length="completedaudits.length"
													:items-per-page="completedaudits_options.itemsPerPage"
													class="light table"
													:footer-props="{
														'items-per-page-options':[
															5,
															10,
															15
														]
													}"
												>
													<template v-slot:item.auditorName="{ item }">
														<span v-if="item.auditorName">
															<v-tooltip top>
																<template v-slot:activator="{ props, on }">
																	<span
																		v-bind="props"
																		v-on="on"
																	>
																		{{ item.auditorName }}
																	</span>
																</template>
																<span v-if="item.auditorType === 1">Internal Onsite-Auditor</span>
																<span v-if="item.auditorType === 2">External Onsite-Auditor's company name</span>
															</v-tooltip>
														</span>
														<span v-else class="error--text font-italic">Auditor need to register</span>
													</template>
													<template v-slot:item.onsiteDate="{ item }">
														<span v-if="item.visitDays && item.onsiteDate">
															{{ item.onsiteDate }}
															<v-tooltip top>
																<template v-slot:activator="{ on, attrs }">
																	<span v-bind="attrs" v-on="on" class="grey--text text--darken-1">
																		({{ item.visitDays }} days)
																	</span>
																</template>
																<span>Number of visit days</span>
															</v-tooltip>
														</span>
														<span v-else>
															{{ item.onsiteDate }}
														</span>
													</template>
													<template v-slot:item.assess="{ item }">
														<v-btn
															:to="'/auditonsite/onsiteaudits/'+item.id"
															color="primary"
															label
															small
															elevation="2"
														>
															<v-icon left small>fas fa-tasks</v-icon>
															
															{{$accessToOperation('AU','U') ? "Assess" : "View"}}
														</v-btn>
													</template>
												</v-data-table>
											</v-tab-item>
											<v-tab-item key="assessed">
												<br />
												<v-data-table
													:loading="loading"
													theme--
													light
													:headers="headersAssessed"
													:items="pagedAssessedAudits"
													:options.sync="assessedaudits_options"
													:server-items-length="assessedaudits.length"
													:items-per-page="assessedaudits_options.itemsPerPage"
													class="light table"
													:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
												>
													<template v-slot:item.auditorName="{ item }">
														<span v-if="item.auditorName">
															<v-tooltip top>
																<template v-slot:activator="{ props, on }">
																	<span
																		v-bind="props"
																		v-on="on"
																	>
																		{{ item.auditorName }}
																	</span>
																</template>
																<span v-if="item.auditorType === 1">Internal Onsite-Auditor</span>
																<span v-if="item.auditorType === 2">External Onsite-Auditor's company name</span>
															</v-tooltip>
														</span>
														<span v-else class="error--text font-italic">Auditor need to register</span>
													</template>
													<template v-slot:item.onsiteDate="{ item }">
														<span v-if="item.visitDays && item.onsiteDate">
															{{ item.onsiteDate }}
															<v-tooltip top>
																<template v-slot:activator="{ on, attrs }">
																	<span v-bind="attrs" v-on="on" class="grey--text text--darken-1">
																		({{ item.visitDays }} days)
																	</span>
																</template>
																<span>Number of visit days</span>
															</v-tooltip>
														</span>
														<span v-else>
															{{ item.onsiteDate }}
														</span>
													</template>
													<template v-slot:item.view="{ item }">
														<v-btn
															:to="'/auditonsite/onsiteaudits/'+item.id"
															color="primary"
															label
															small
															elevation="2"
														>
															<v-icon left small>far fa-eye</v-icon>
															{{item.view}}
															View
														</v-btn>
													</template>
													<template  v-slot:item.expiryDate="{ item }">
														<p  v-if="$moment(item.expiryDate).isBefore($moment())" style="color: red ;margin-bottom: 0px">{{item.expiryDate | moment("DD/MM/YYYY")}}
															<v-icon color="red" style="margin:5px" >fas fa-times-circle</v-icon>
														</p>
														<p v-else style="margin-bottom: 0px">{{item.expiryDate | moment("DD/MM/YYYY")}}</p>
													</template>
												</v-data-table>
											</v-tab-item>
										</v-tabs>
								</v-card>
							</v-col>
						</v-row>
					</v-tab-item>
				</v-tabs>
			</v-col>
			<v-dialog v-model="dialogDelete" max-width="500px">
				<v-card>
					<v-card-title>
						Are you sure you want to remove
						<br />this audit request?
					</v-card-title>
					<v-card-actions>
						<v-btn color="primary" text @click="dialogDelete = false">Close</v-btn>
						<v-btn color="error" text @click="removeRow">Delete</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<v-dialog 
				v-model="dialogRequestView"
				max-width="1200px"
				height="auto"
				scrollable
				align = "center">
				<v-card>
					<v-card-text class="background-color: white" v-if="previewTemplateID!=null">		
						<template-preview
							:previewID="previewTemplateID"
							:preview="false"
							:submitterName="submitterName"
						/>
					</v-card-text>
					<v-card-actions>
						<v-btn 
							color="primary" 
							text 
							@click="dialogRequestView = false; submitterName = null; previewTemplateID=null" 
							outlined
						>Close</v-btn
						>
					</v-card-actions>
				</v-card>
			</v-dialog>    
		</v-row>
	</v-container>
</template>

<script>
import AuditsAPI from "../../api/audit/audit"
import LoadingState from "../../consts/LoadingState"
import AuditRequestsAPI from "../../api/audit/request"
import TemplatePreview from "../auditonsite/OnsiteTemplatePreview.vue"
import TemplateRequestAPI from "../../api/audit/template"
import { mapGetters,mapActions,mapState } from "vuex"
//import { mapState } from "vuex";
import UpgradePackageAPI from "../../api/billing"

export default {
	name: "ClientAuditOnsiteOverview",
	components: {
		"template-preview" : TemplatePreview
	},
	data() {
		return {
			headersCompleted: [
				{
					text: "Onsite-Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Supplier",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Time",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
			],

			headersAssessed: [
				{
					text: "Onsite-Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Supplier",
					value: "sender",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Status",
					value: "status",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],
			headersPending: [
				{
					text: "Audit Template",
					value: "template",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Supplier",
					value: "sender" || "invitationCodeName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Date",
					value: "onsiteDate",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],
			headersTemplates: [
				{
					text: "Audit Template",
					value: "templateName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Onsite-Auditor",
					value: "auditorName",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Timestamp",
					value: "timestamp",
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "Status",
					value: "status", 
					sortable: false,
					class: "darkColor--text"
				},
				{
					text: "View",
					value: "view",
					sortable: false,
					class: "darkColor--text"
				}
			],
			assessment: "notAssessed",
			completedaudits: [],
			completedaudits_options: {
				page: 1,
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				supplierName: null,
				sort: null
			},
			completedaudits_total: 0,
			assessedaudits: [],
			assessedaudits_options: {
				page: 1,
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				supplierName: null,
				sort: null 
			},
			assessedaudits_total: 0,
			pendingaudits: [],
			pendingaudits_options: {
				page: 1,
				itemsPerPage: 5,
				templateName: null,
				senderName: null,
				auditor: null,
				sort: null
			},
			pendingtemplates_options: {
				page: 1,
				itemsPerPage: 5,
				templateName: null,
				auditorName: null,
				sort: null
			},
			pendingaudits_total: 0,
			loading: false,
			id: false,
			client: false,
			timestamp: false,
			template: false,
			dialogDelete: false,
			submitterName: null,
			previewTemplateID: null,
			dialogRequestView: false,
			// For assessed audits - search
			templateName: null,
			senderName: null,
			supplierName: null,
			sort: null,
			// For completed audits - search
			comp_sort: null,
			comp_templateName: null,
			comp_senderName: null,
			pending_templateName: null,
			pending_recipientName: null,
			pending_auditor: null,
			pending_sort: null,
			allTemplateIDs: [],
			options: {},
			pending: "pendingtemplate",
			templateApprovals: [],
			allTemplateApprovals: [],
		}
	},
	computed: {
		...mapGetters({
			isLoggedIn: "user/isLoggedIn",
			getUser: "user/getUser",
			isApproved: "audit/template/isApproved",
		}),
		...mapState("audit/template", {
			approval: state => state.approval
		}),
		clientName() {
			return this.getUser.clientName
		},
		pagedCompletedAudits() {
			const start = (this.completedaudits_options.page - 1) * this.completedaudits_options.itemsPerPage
			const end = start + this.completedaudits_options.itemsPerPage
			return this.completedaudits.slice(start, end)
		},
		pagedAssessedAudits() {
			const start = (this.assessedaudits_options.page - 1) * this.assessedaudits_options.itemsPerPage
			const end = start + this.assessedaudits_options.itemsPerPage
			return this.assessedaudits.slice(start, end)
		},
		pagedPendingAudits() {
			const start = (this.pendingaudits_options.page - 1) * this.pendingaudits_options.itemsPerPage
			const end = start + this.pendingaudits_options.itemsPerPage
			return this.pendingaudits.slice(start, end)
		},
		pagedTemplateApprovals() {
			const start = (this.pendingtemplates_options.page - 1) * this.pendingtemplates_options.itemsPerPage
			const end = start + this.pendingtemplates_options.itemsPerPage
			return this.templateApprovals.slice(start, end)
		}
	},
	mounted() {
		this.loadCompletedAudits()
		this.loadAssessedAudits()
		this.loadPendingAudits()
		this.loadTemplateRequests()
		
		let hasAccess = this.$accessToOperation("AU","U")
		if (hasAccess) {
			this.headersCompleted.push(
				{
					text: hasAccess ? "Assess" : "View",
					value: "assess",
					sortable: false,
					class: "darkColor--text"
				}
			)
		}

		let hasDeleteAccess = this.$accessToOperation("AR","D")
		if (hasDeleteAccess) {
			this.headersPending.push(
				{
					text: "Remove",
					value: "remove",
					sortable: false,
					class: "darkColor--text"
				}
			)
		}
	},
	methods: {
		...mapActions("audit/template", ["approveTemplate"]),
		continueRequest(item){
			const templateID = item?.templateID
			const auditorName = item?.auditorName || ""

			if (!templateID) {
				throw new Error("Template ID not found.")
			}
			
			if (!this.isApproved) {
				this.approveTemplate({ id: templateID, approval: true })
			}

			this.$router.push({
				path: "/auditonsite/onsitesender/newonsite",
				query: {
					templateID,
					auditorName,
					step: "3"
				}
			})
		},
		loadCompletedAudits() {
			let hasAccess = this.$accessToOperation("AU","U")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)

			this.loading = true
			const { templateName, senderName, supplierName, sort } = this.completedaudits_options
			AuditsAPI.onsiteList({type: "incoming", status: "0", limit: 200, offset: 0,  otherParams:{templateName, senderName, supplierName, sort}})
				.then(result => {
					this.completedaudits = result.items.map(entry => {
						let onsiteDate = null
						if(entry.fromDate && entry.toDate) {
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
						}else if(entry.fromDate){
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
						}else if(entry.toDate){
							onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
						}
						return{
							id: entry.id,
							sender: entry.recipientUsername || entry.supplierName,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							auditorName: entry.senderName,
							auditorType: entry.auditorType,
							onsiteDate: onsiteDate,
							visitDays: entry.visitDays ?? null,
							assess: hasAccess ? null : undefined
						}
					})
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},

		async checkPackageAndNavigate() {
			try {

				this.$store.dispatch("loading/RESET_ERROR", null, { root: true })

				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					null,
					{ root: true }
				)

				const packageInfo = await UpgradePackageAPI.getUpgradePackages()
				console.log("Package Info:", packageInfo)

				if (!packageInfo) {
					throw new Error(
						"You need to upgrade your package plan to send an Onsite Audit Request. You need AUDIT or PREMIUM package."
					)
				}

				let planKey = null
				if (packageInfo.PlanKey) {
					planKey = packageInfo.PlanKey
				} else if (packageInfo.packages && packageInfo.packages.length > 0) {
					planKey = packageInfo.packages[0].PlanKey
				}

				const allowedPlans = ["AU", "FTA", "Pre", "FTP"]
				if (!allowedPlans.includes(planKey)) {
					throw new Error(
						"You don't have a valid package. Please get AUDIT or PREMIUM package to send Onsite Audit Requests."
					)
				}

				const currentDate = new Date()
				let registerDate = null
				let monthYear = null

				if (packageInfo.RegisterTime) {
					registerDate = new Date(packageInfo.RegisterTime)
					monthYear = packageInfo.MonthYear
				} else if (packageInfo.packages && packageInfo.packages[0]) {
					registerDate = new Date(packageInfo.packages[0].RegisterTime)
					monthYear = packageInfo.packages[0].MonthYear
				}

				if (registerDate && monthYear !== null) {
					let expiryDate = new Date(registerDate)
					
					if (monthYear === 0) {
						expiryDate.setDate(expiryDate.getDate() + 30)
					} else if (monthYear === 1) {
						expiryDate.setDate(expiryDate.getDate() + 365)
					}

					if (currentDate > expiryDate) {
						throw new Error("Your package has expired. Please renew your plan to continue using Onsite Audit features.")
					}
				}

				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)

				this.$router.push("/auditonsite/onsitesender/newonsite")

			} catch (error) {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error.message,
					{ root: true }
				)
			}
		},

		loadAssessedAudits() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			this.loading = true
			const { templateName, senderName, supplierName, sort } = this.assessedaudits_options
			AuditsAPI.onsiteList({type: "incoming", notStatus: "0", limit: 200, offset: 0, otherParams:{templateName, senderName, supplierName, sort}})
				.then(result => {
					this.assessedaudits = result.items.map(entry => {
						const statusname = {
							0: "Pending",
							1: "Approved",
							2: "Conditionally Approved",
							3: "Denied"
						}
						let onsiteDate = null
						if (entry.fromDate && entry.toDate) {
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
						}else if(entry.fromDate){
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
						}else if(entry.toDate){
							onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
						}
						return {
							id: entry.id,
							sender: entry.recipientUsername || entry.supplierName,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							expiryDate: entry.expiryDate,
							template: entry.templateName,
							auditorName: entry.senderName,
							auditorType: entry.auditorType,
							onsiteDate: onsiteDate,
							visitDays: entry.visitDays ?? null,
							status: statusname[entry.status],
							view: null
						}
					})
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		
		loadPendingAudits() {
			let hasDeleteAccess = this.$accessToOperation("AR","D")
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			this.loading = true
			const { templateName, recipientName, auditorName,  sort } = this.pendingaudits_options
			AuditRequestsAPI.onsiteList({type: "outgoing", offset: 0, limit: 200, otherParams:{templateName, recipientName, auditorName, sort}})
				.then(result => {
					this.pendingaudits = result.items.map(entry => {
						let onsiteDate = null
						if (entry.fromDate && entry.toDate) {
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY") + " - " + this.$moment(entry.toDate).format("DD/MM/YYYY")
						}else if(entry.fromDate){
							onsiteDate = this.$moment(entry.fromDate).format("DD/MM/YYYY")
						}else if(entry.toDate){
							onsiteDate = this.$moment(entry.toDate).format("DD/MM/YYYY")
						}
						return {
							id: entry.requestID,
							sender: entry.supplierName || entry.recipientName || entry.invitationCodeName,
							timestamp: this.$moment(entry.timestamp).format("DD/MM/YYYY HH:mm:ss"),
							template: entry.templateName,
							templateID: entry.templateID,
							auditorName: entry.auditorName,
							auditorType: entry.auditorType,
							onsiteDate: onsiteDate,
							visitDays: entry.visitDays ?? null,
							remove: hasDeleteAccess ? null : undefined
						}
					})
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.loading = false
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		loadTemplateRequests(){
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			
			TemplateRequestAPI.getOnsiteTemplateRequest(this.clientName)
				.then(result => {
					
					this.allTemplateApprovals = []
					for (let entry of result) {	
						this.allTemplateApprovals.push({
							templateID: entry.TemplateID,
							templateName: entry.TemplateName,
							auditorName: entry.AuditorName,
							auditorType: entry.AuditorType,
							timestamp: this.$moment(entry.Timestamp).format("DD/MM/YYYY HH:mm:ss"),
							timestampRaw: entry.Timestamp,
							preview: null,
							templateApproval: entry.TemplateApproval
						})
						
					}
					this.allTemplateApprovals.sort((a, b) => {
						return new Date(b.timestampRaw) - new Date(a.timestampRaw)
					})
					this.applyTemplateFilters()
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		applyTemplateFilters() {
			let filteredData = [...this.allTemplateApprovals]
			if (this.pendingtemplates_options.templateName) {
				filteredData = filteredData.filter(item => 
					item.templateName.toLowerCase().includes(this.pendingtemplates_options.templateName.toLowerCase())
				)
			}
			
			if (this.pendingtemplates_options.auditorName) {
				filteredData = filteredData.filter(item => 
					item.auditorName && item.auditorName.toLowerCase().includes(this.pendingtemplates_options.auditorName.toLowerCase())
				)
			}
			this.templateApprovals = filteredData
		},
		showDeleteDialog(item) {
			this.itemToDelete = item
			this.dialogDelete = !this.dialogDelete
		},

		showRequestDialog(item) {
			this.submitterName = item.sender || item.invitationCodeName
			this.previewTemplateID = item.templateID
			this.dialogRequestView = true
		},

		removeRow() {
			this.dialogDelete = false
			let index = this.pendingaudits.indexOf(this.itemToDelete)
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			AuditRequestsAPI.deleteRequest(this.itemToDelete.id)
				.then(() => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_LOADING_SUCCESS,
						"Audit was successfully removed from the list.",
						{ root: true }
					)
					this.pendingaudits.splice(index, 1)
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		
		search(type) {
			if (type == "a" || type == "c") {
				this.assessedaudits_options.templateName = this.templateName
				this.assessedaudits_options.senderName = this.senderName
				this.assessedaudits_options.supplierName = this.supplierName
				this.assessedaudits_options.sort = this.sort
				
				this.completedaudits_options.templateName = this.templateName
				this.completedaudits_options.senderName = this.senderName
				this.completedaudits_options.supplierName = this.supplierName
				this.completedaudits_options.sort = this.comp_sort

				this.loadAssessedAudits()
				this.loadCompletedAudits()
			} else if (type == "p") {
				this.pendingaudits_options.templateName = this.pending_templateName
				this.pendingaudits_options.recipientName = this.pending_recipientName
				this.pendingaudits_options.auditorName = this.pending_auditor
				this.pendingaudits_options.sort = this.pending_sort
				
				this.pendingtemplates_options.templateName = this.pending_templateName
				this.pendingtemplates_options.auditorName = this.pending_auditor
				this.pendingtemplates_options.sort = this.pending_sort


				this.loadPendingAudits()	
				this.applyTemplateFilters()
			}
		},
		
		clear(type) {
			if (type == "a" || type == "c") {
				this.assessedaudits_options.templateName = null
				this.assessedaudits_options.senderName = null
				this.assessedaudits_options.supplierName = null
				this.assessedaudits_options.sort = null
				this.completedaudits_options.templateName = null
				this.completedaudits_options.senderName = null
				this.completedaudits_options.supplierName = null
				this.completedaudits_options.sort = null
				this.templateName = null
				this.senderName = null
				this.supplierName = null

				this.loadAssessedAudits()
				this.loadCompletedAudits()
			} else if (type == "p") {
				this.pendingaudits_options.templateName = null
				this.pendingaudits_options.recipientName = null
				this.pendingaudits_options.auditorName = null
				this.pendingaudits_options.sort = null

				this.pendingtemplates_options.templateName = null
				this.pendingtemplates_options.auditorName = null
				this.pendingtemplates_options.sort = null

				this.pending_templateName = null
				this.pending_recipientName = null
				this.pending_auditor = null
				
				this.applyTemplateFilters()
				this.loadPendingAudits()	

				this.loadPendingAudits()	
			}
		},
		
		setSort(type, sort) {
			if (sort != "id_asc" && sort != "id_desc") {
				return
			}

			if (type == "a") {
				if (this.sort == sort) {
					this.sort = null
					return
				}
				this.sort = sort
			} else if (type == "c") {
				if (this.comp_sort == sort) {
					this.comp_sort = null
					return
				}
				this.comp_sort = sort
			}
		}
	},
	watch: {
		completedaudits_options: {
			handler () {
				this.loadCompletedAudits()
			},
			deep: true,
		},
		assessedaudits_options: {
			handler () {
				this.loadAssessedAudits()
			},
			deep: true,
		},
		pendingaudits_options: {
			handler () {
				this.loadPendingAudits()
			},
			deep: true,
		},
		pendingtemplates_options: {
			handler () {
				this.applyTemplateFilters()
			},
			deep: true,
		},
	},
}
</script>